import { render, staticRenderFns } from "./AnexarDocumentos.vue?vue&type=template&id=409f30a0&"
import script from "./AnexarDocumentos.vue?vue&type=script&lang=js&"
export * from "./AnexarDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports